export class NotificationAPIModel {
  GetNotificationAPI: string = "";
  ReadNotificationAPI: string = "";
}
